import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  OnChanges,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { BsModalRef, BsModalService, ModalDirective } from "ngx-bootstrap";
import { Observable } from "rxjs";
import { PDFDocumentProxy, PDFProgressData } from "ng2-pdf-viewer";
import { env } from "@env/environment";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { ISubscription } from "rxjs-compat/Subscription";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  // tslint:disable-next-line:component-selector
  selector: "modale-preview-pdf",
  templateUrl: "modale-preview-pdf.component.html",
  providers: [],
})
export class ModalePreviewComponent implements OnChanges, OnDestroy {
  @ViewChild("templatePreviewPdf", { static: false })
  public templatePreviewPdf: TemplateRef<any>;
  public modalRef: BsModalRef;
  cambiamentiCollegamenti: boolean;
  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true,
  };

  @Input() public idDocumento: string;

  @Input() public anteprimaDecreto: boolean;

  @Input() public downloadFileName: string = 'anteprima-decreto.pdf';

  @Input() public urlLocale: string;


  @Input() public showPreview: boolean;

  @Input() public orientation: 'horizontal' | 'vertical' = 'vertical';

  @Output()
  public previewClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  public pdfSrc: any;
  public pdfPage: number = 1;
  public pdfPageNumber: number;
  public completed: boolean = false;
  public onError: boolean = false;

  private basePdfSrc = env.API_URL_BASE + env.URL_PREVIEW_DOC;
  private utenteSubscribe: ISubscription;
  private accessToken: string;

  constructor(private sanitizer: DomSanitizer, private autenticazioneService: AutenticazioneService, private modalService: BsModalService) {
    this.utenteSubscribe = this.autenticazioneService.utenteAnnounced$.subscribe(user => {
      this.accessToken = user.token;
      this.setPdfSource();
    });
  }

  public openModal() {
    console.log("this.pdfSrc: ", this.idDocumento);

    // Configurazione dinamica basata sull'orientamento
    const modalConfig = {
      class: this.orientation === 'horizontal'
        ? "modal-dialog modal-info modal-sidebar-left modal-xlg"
        : "modal-dialog modal-info modal-xlg",
      animated: true,
    };

    this.modalRef = this.modalService.show(
      this.templatePreviewPdf,
      modalConfig
    );
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public closePreview() {
    this.hidePreviewModal();
    this.previewClosed.emit(true);
  }

  public hidePreviewModal(): boolean {
    this.completed = false;
    this.onError = false;
    this.modalRef.hide();
    return true;
  }

  public onLoadComplete(pdf: PDFDocumentProxy) {
    console.log("callBackFn pdf: ", pdf);
    this.pdfPageNumber = pdf.numPages;
    this.completed = true;
  }

  public onLoadError(error: any) {
    console.log("Errore anteprima", error);
    this.onError = true;
  }

  public ngOnChanges(): void {
    this.setPdfSource();
  }

  public setPdfSource() {
    if (this.idDocumento) {
      this.pdfSrc = {
        url: this.basePdfSrc + this.idDocumento,
        httpHeaders: { Authorization: "Bearer " + this.accessToken },
        withCredentials: false,
      };
    } else {
      this.pdfSrc = {
        url: this.urlLocale
      };
    }
  }

  ngOnDestroy(): void {
    if (this.utenteSubscribe) {
      this.utenteSubscribe.unsubscribe();
    }
  }

}
